import script from "./MyButton2.vue?vue&type=script&setup=true&lang=js"
export * from "./MyButton2.vue?vue&type=script&setup=true&lang=js"

import "./MyButton2.vue?vue&type=style&index=0&id=66e0f200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e0f200"]])

export default __exports__